import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=4fe79f36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe79f36"]])

export default __exports__